export default __webpack_public_path__ + "static/constellationTarpit-e14cb3fd8d56d42a7a6595fc6c18c59c.svg";